import * as React from 'react';
import styles from './index.less';
import img_card from './assets/card.png';
import img_cash from './assets/cash.png';
import img_code from './assets/code.png';
import img_friend from './assets/friend.png';
import img_invite from './assets/invite.png';
import copy from 'copy-to-clipboard';
import { FUtil, FServiceAPI, FI18n } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import * as AHooks from 'ahooks';
import FFooter from '@/components/Footer';
import FComponentsLib from '@freelog/components-lib';
import { connect } from 'dva';
import { ActivityDetailsPageModelState, ConnectState } from '@/models/connect';

const states = {
  expire: '已过期',
  onRoad: '在路上',
  received: '已到账',
} as const;

interface InviteFriendProps {
  // dispatch: Dispatch;
  activityDetailsPage: ActivityDetailsPageModelState;
}

function InviteFriend({ activityDetailsPage }: InviteFriendProps) {
  const [showInvite, setShowInvite] = FUtil.Hook.useGetState<boolean>(false);
  const [userData, setUserData] = FUtil.Hook.useGetState<any>({});
  const [records, setRecords] = FUtil.Hook.useGetState<
    {
      userId: number;
      username: string;
      createDate: string;
      email: string;
      mobile: string;
      state: 'expire' | 'onRoad' | 'received';
    }[]
  >([]);

  AHooks.useMount(() => {
    self._czc?.push(['_trackPageview', self.location.pathname]);
    getData();
  });

  async function getData() {
    const userID: number = FUtil.Tool.getUserIDByCookies();
    if (userID !== -1) {
      const {
        data: data_invitees,
      }: {
        data: {
          userId: number;
          username: string;
          invitedDate: string;
          email: string;
          mobile: string;
        }[];
      } = await FServiceAPI.TestQualification.invitees({ userId: userID });
      // console.log(data, 'task093iolksdfjlsdkfjlsdfjk');
      // setRecords(task.data.dataList);

      const { data: data_friendInfos } = await FServiceAPI.Activity.listInviteFriendInfos(
        data_invitees.map((di) => {
          return {
            userId: di.userId,
            username: di.username,
            createDate: di.invitedDate,
          };
        }),
      );

      // console.log(
      //   data_friendInfos,
      //   '111data_friendInfosi9oewdsfklsdjflsdkjflsdkjflkj',
      // );

      setRecords(
        data_invitees.map((d) => {
          const status: 0 | 1 | 3 =
            data_friendInfos.find((df: any) => {
              return df.friendId === d.userId;
            })?.status || 0;

          let state: 'expire' | 'onRoad' | 'received';

          switch (status) {
            case 0:
              state = 'expire';
              break;
            case 1:
              state = 'onRoad';
              break;
            case 3:
              state = 'received';
              break;
          }
          return {
            ...d,
            createDate: FUtil.Format.formatDateTime(d.invitedDate),
            state,
          };
        }),
      );
    }

    const res = await FServiceAPI.TestQualification.codeDetails2({});
    let userInfo = { data: {} };
    userInfo = userID > -1 ? await FServiceAPI.User.currentUserInfo() : userInfo;
    // console.log(userInfo);
    // setUserData({
    //   userInfo: userInfo.data,
    //   ...res.data,
    //   textCopy: `邀你一起参与Freelog内测啦！Freelog是国内首家基于智能合约的资源自动化交易平台，参与内测活动至少可领【58元】现金奖励，发布图片、小说、漫画等资源还可赢取【3000元】现金奖励！活动仅限800人，快快戳链接注册参与吧！
    // \n邀请码${
    //     ' ' + res.data.code + ' '
    //   }\n\n 前往Freelog注册：https://www.freelog.com/`,
    // });
    setUserData({
      userInfo: userInfo.data,
      ...res.data,
      textCopy: `邀你一起参与Freelog内测啦！Freelog，国内首家基于智能合约的资源自动化交易平台，参与内测至少可领【43元】现金奖励，发布小说、漫画等资源还可赢取【2000元】现金奖励！活动仅限800人，快快戳链接注册参与吧！


前往Freelog注册：${FUtil.Format.completeUrlByDomain('user') + FUtil.LinkTo.logon({ invitationCode: res.data.code })}


邀请码：${res.data.code}
`,
    });
  }

  function scrollToAnchor(anchorName: any) {
    let state: any = {
      behavior: 'smooth',
      block: 'start',
    };
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView(state);
      }
    }
  }

  return (
    <div
      // className={'invite-friend flex-column align-center y-auto'}
      className={styles.inviteFriend}
      style={{
        display: 'flex',
        flexFlow: 'column',
        position: 'relative',
        alignItems: 'center',
        // overflowY: 'auto',
      }}
    >
      <div
        // className={'flex-column align-center y-auto w-100x'}
        style={{
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
          overflowY: 'auto',
          width: '100%',
        }}
        onClick={() => setShowInvite(false)}
      >
        <div
          // className='h-680 flex-column-center w-100x '
          style={{
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            width: '100%',
            height: '680px',
          }}
        >
          <div
            //  className='w-100x h-100x over-h'
            style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            <img
              src={img_invite}
              alt=''
              // className='h-100x banner-img'
              className={styles.bannerImg}
              style={{
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </div>
          <div
            // className='banner-container flex-column-center w-100x'
            className={styles.bannerContainer}
            style={{
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <div
              // className='banner'
              className={styles.banner}
            >
              <div
                // className='flex-row mb-15  align-end'
                style={{
                  display: 'flex',
                  position: 'relative',
                  marginBottom: '15px',
                  alignItems: 'flex-end',
                }}
              >
                <span />
                <span
                  // className='title'
                  className={styles.title}
                >
                  邀请好友一起参与内测，可领20元现金奖励！
                </span>
                <span
                  // className='tip'
                  className={styles.tip}
                >
                  (被邀请好友参与内测可领3元现金奖励)
                </span>
              </div>
              <div
                // className='flex-row mb-15'
                style={{
                  display: 'flex',
                  position: 'relative',
                  marginBottom: '15px',
                }}
              >
                <span />
                <span
                  // className='title'
                  className={styles.title}
                >
                  同时抽取5位成功邀请好友的用户赠送价值100元的京东购物卡！
                </span>
              </div>
              <div
                //  className='flex-row mb-70'
                style={{
                  display: 'flex',
                  position: 'relative',
                  marginBottom: '70px',
                }}
              >
                <span />
                <span
                  // className='title'
                  className={styles.title}
                >
                  内测活动仅限200人，快快邀请好友参与吧！
                </span>
              </div>
              <div
                // className='flex-row align-end'
                style={{
                  display: 'flex',
                  position: 'relative',
                  alignItems: 'flex-end',
                }}
              >
                <span />
                <span
                  // className='title'
                  className={styles.title}
                >
                  更多现金奖励领取方式尽在
                </span>
                <a
                  // className='way px-10'
                  className={styles.way}
                  style={
                    {
                      // paddingLeft: '10px',
                    }
                  }
                  href={FI18n.i18nNext.tAuto('beta_event_referralprogram_guideline_link')}
                  target={'_blank'}
                >
                  Freelog内测玩法指南
                </a>
                <span
                  // className='tip'
                  className={styles.tip}
                >
                  (至少可领43元现金奖励哦!)
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          // className='flex-column praise w-100x align-center'
          className={styles.praise}
          style={{
            display: 'flex',
            flexFlow: 'column',
            position: 'relative',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div
            // className='category'
            className={styles.category}
          >
            <div
              // className='invite-circle active-reward'
              className={[styles.inviteCircle, styles.activeReward].join(' ')}
            >
              <div
                // className='circle-inside'
                className={styles.circleInside}
              />
            </div>
            <span>活动奖励</span>
          </div>
          <div
            //  className='container flex-column align-center'
            className={styles.container}
            style={{
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
            }}
          >
            <span
              // className='title mt-50'
              className={styles.title}
              style={{
                marginTop: '50px',
              }}
            >
              奖励一
            </span>
            <div
              // className='flex-row title2 align-end'
              className={styles.title2}
              style={{
                display: 'flex',
                position: 'relative',
                alignItems: 'flex-end',
              }}
            >
              活动期间，成功邀请好友参与Freelog内测，可获得对应现金奖励，累计最高可得
              <span className={styles.cash}>20元</span>
              <span className={styles.cash}>现金</span>
            </div>
            <div
              // className='h-180 over-h '
              style={{
                height: 180,
                overflow: 'hidden',
              }}
            >
              <img
                src={img_cash}
                alt=''
                // className={styles.cashImg}
                style={{ width: 700 }}
              />
            </div>
            <span
              // className='title mt-50'
              className={styles.title}
              style={{
                marginTop: '50px',
              }}
            >
              奖励二
            </span>
            <div
              // className='flex-row title2 align-end'
              className={styles.title2}
              style={{
                display: 'flex',
                position: 'relative',
                alignItems: 'flex-end',
              }}
            >
              <span>抽取5位成功邀请好友的用户，赠送价值</span>
              <span
                // className='cash '
                className={styles.cash}
              >
                100元
              </span>
              <span>的京东购物卡（电子卡）！</span>
            </div>
            <div
              // className='h-220 over-h '
              style={{
                height: 220,
                overflow: 'hidden',
              }}
            >
              <img
                src={img_card}
                alt=''
                // className={styles.cardImg}
                style={{ width: 357 }}
              />
            </div>
          </div>
        </div>
        <div
          // className='flex-column steps w-100x align-center'
          className={styles.steps}
          style={{
            display: 'flex',
            flexFlow: 'column',
            position: 'relative',
            alignItems: 'center',
          }}
        >
          <div
            // className='category'
            className={styles.category}
          >
            <div
              // className='invite-circle active-step'
              className={[styles.inviteCircle, styles.activeStep].join(' ')}
            >
              <div className={styles.circleInside} />
            </div>
            <span>参与步骤</span>
          </div>
          <div
            // className={
            //   'container flex-column align-center pt-50 ' +
            //   (records.length != 0 ? 'h-796' : 'h-460')
            // }
            className={styles.container}
            style={{
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
              paddingTop: '50px',
              height: records.length != 0 ? 796 : 460,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
              }}
              // className={'des'}
              className={styles.des}
            >
              <div
                style={{
                  flexBasis: '25%',
                  textAlign: 'center',
                }}
                // className={'des'}
                className={styles.des}
              >
                {/*向好友分享*/}
                分享邀请码
                <br />
                给好友
              </div>
              <div
                style={{
                  flexBasis: '25%',
                  textAlign: 'center',
                }}
              >
                好友完成
                <br />
                Freelog网站注册
              </div>
              <div
                style={{
                  flexBasis: '25%',
                  textAlign: 'center',
                }}
                // className={' '}
                className={styles.des}
              >
                好友用邀请码
                <br />
                激活内测资格
              </div>
              <div
                style={{
                  flexBasis: '25%',
                  textAlign: 'center',
                }}
                // className={'des'}
                className={styles.des}
              >
                奖励
                <br />
                到账
              </div>
            </div>
            <div style={{ height: 40 }} />
            <div
              // className='flex-row w-100x mt-40 pl-43 pr-71  align-center'
              style={{
                display: 'flex',
                width: '100%',
                // marginTop: '40px',
                // paddingLeft: '43px',
                // paddingRight: '71px',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxSizing: 'border-box',
                padding: '0 100px',
              }}
            >
              {/* <div
                // className=' flex-column-center pl-65 pr-20'
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  alignItems: 'center',
                  paddingLeft: '65px',
                  paddingRight: '20px',
                }}
              >

              </div> */}
              <div
                // className='step flex-column-center'
                className={styles.step}
                style={{
                  display: 'flex',
                  // flexFlow: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                1
              </div>
              <div
                // className='arrow'
                className={styles.arrow}
              />
              {/* <div
                // className=' flex-column-center px-20'
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  alignItems: 'center',
                }}
              > */}
              <div
                className={styles.step}
                style={{
                  display: 'flex',
                  // flexFlow: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                2
              </div>
              {/* </div> */}
              <div
                // className='arrow'
                className={styles.arrow}
              />
              {/* <div
                // className=' flex-column-center px-20 p-rel'
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  alignItems: 'center',
                  position: 'relative',
                }}
              > */}
              <div
                // className='step flex-column-center mt-12'
                className={styles.step}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                3
              </div>
              <div
                //  className='arrow'
                className={styles.arrow}
              />
              {/* <div
                // className=' flex-column-center px-20'
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  alignItems: 'center',
                }}
              > */}
              <div
                // className='step flex-column-center'
                className={styles.step}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                4
              </div>
              {/* </div> */}
            </div>

            <FComponentsLib.FRectBtn
              // className='invite-button mt-88'
              className={styles.inviteButton}
              style={{
                marginTop: '88px',
              }}
              disabled={
                userData.usedCount >= userData.limitCount ||
                activityDetailsPage.timeValidity !== 'Validity'
              }
              onClick={(e) => {
                if (!userData.limitCount) return;
                if (userData.userInfo.userType != 1) {
                  fMessage(<span>此活动仅对内测用户开放!</span>, 'warning');
                  return;
                }
                self._czc?.push(['_trackEvent', '邀请好友页', '立即邀请', '', 1]);
                setShowInvite(true);
                e.stopPropagation();
              }}
            >
              {/*{taskInfo.status === 4 ? '立即邀请' : status[taskInfo.status]}*/}
              {activityDetailsPage.timeValidity === 'NotStart'
                ? '即将开始'
                : activityDetailsPage.timeValidity === 'Finished'
                  ? '已经结束'
                  : userData.limitCount
                    ? '立即邀请'
                    : '登录后立即邀请'}
            </FComponentsLib.FRectBtn>
            <div
              // className='flex-row w-260 space-between mt-10'
              style={{
                display: 'flex',
                width: '260px',
                justifyContent: 'space-between',
                marginTop: '10px',
              }}
            >
              {userData.limitCount && (
                <span
                  // className='invite-left'
                  className={styles.inviteLeft}
                >
                  还可邀请 {userData.limitCount - userData.usedCount} 位好友
                </span>
              )}
              {userData.usedCount < 5 && (
                <a
                  // className='get-more link'
                  className={[styles.getMore, styles.link].join(' ')}
                  onClick={() => {
                    self._czc?.push(['_trackEvent', '邀请好友页', '获取更多邀请名额', '', 1]);
                    scrollToAnchor('inner-test');
                  }}
                >
                  获取更多名额
                </a>
              )}
            </div>
            {records.length != 0 && (
              <div
                // className='record mt-60 w-100x'
                className={styles.record}
                style={{
                  marginTop: '60px',
                  width: '100%',
                }}
              >
                <div
                  // className='flex-row title-row align-end'
                  className={styles.titleRow}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                  }}
                >
                  <div
                    // className='flex-row align-end c1'
                    className={styles.c1}
                    style={{
                      display: 'flex',
                      position: 'relative',
                      alignItems: 'flex-end',
                    }}
                  >
                    <span
                      //  className='title'
                      className={styles.title}
                    >
                      我的邀请记录
                    </span>
                    {/*<span className='tip'>*/}
                    {/*  好友在注册后的7天内完成指定任务，即可领取奖励*/}
                    {/*</span>*/}
                  </div>
                  <span
                    // className='tip c2'
                    className={[styles.tip, styles.c2].join(' ')}
                  >
                    最近更新
                  </span>
                  <span
                    //  className='tip c3'
                    className={[styles.tip, styles.c3].join(' ')}
                  >
                    奖励进度
                  </span>
                </div>

                {records.length === 0 && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 100,
                    }}
                  >
                    <FComponentsLib.FContentText text={'暂无'} type={'additional2'} />
                  </div>
                )}
                {records.map((r) => {
                  return (
                    <div
                      // className='flex-row row'
                      className={styles.row}
                      style={{
                        display: 'flex',
                      }}
                      key={r.userId}
                    >
                      <span
                        // className='item c1'
                        className={[styles.item, styles.c1].join(' ')}
                      >
                        {r.username}（{r.mobile || r.email || '****'}）
                      </span>
                      <span
                        // className='item c2'
                        className={[styles.item, styles.c2].join(' ')}
                      >
                        {r.createDate}
                      </span>
                      <span
                        // className='item c3'
                        className={[styles.item, styles.c3].join(' ')}
                      >
                        {states[r.state] || '未知'}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div
          // className='flex-column tutorial w-100x align-center'
          className={styles.tutorial}
          style={{
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div
            // className='category'
            className={styles.category}
          >
            <div
              // className='invite-circle active-policy'
              className={[styles.inviteCircle, styles.activePolicy].join(' ')}
            >
              <div
                // className='circle-inside'
                className={styles.circleInside}
              />
            </div>
            <span>邀请攻略</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: 1060 }}>
            <div style={{ width: 515 }}>
              <img src={img_friend} alt='' style={{ width: '100%' }} />
            </div>
            <div style={{ width: 515 }}>
              <img src={img_code} alt='' style={{ width: '100%' }} />
            </div>
          </div>
        </div>
        <div
          // className='flex-column rule w-100x align-center'
          className={styles.rule}
          style={{
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            width: '100%',
          }}
          id='inner-test'
        >
          <div
            //  className='category'
            className={styles.category}
          >
            <div
              // className='invite-circle active-rule'
              className={[styles.inviteCircle, styles.activeRule].join(' ')}
            >
              <div
                // className='circle-inside'
                className={styles.circleInside}
              />
            </div>
            <span>活动规则</span>
          </div>
          <div
            // className='flex-column container space-between'
            className={styles.container}
            style={{
              display: 'flex',
              flexFlow: 'column',
              position: 'relative',
              justifyContent: 'space-between',
              alignContent: 'space-between',
            }}
          >
            <span>
              1.&nbsp; &nbsp;内测活动时间：
              {activityDetailsPage.startTime?.format('YYYY/MM/DD') || 'YYYY/MM/DD'} -{' '}
              {activityDetailsPage.endTime?.format('YYYY/MM/DD') || 'YYYY/MM/DD'}；
            </span>
            {/*<span className=''>*/}
            {/*  2.&nbsp;*/}
            {/*  &nbsp;内测活动仅限800名用户参与，在Freelog内测用户满800人后，邀请好友活动暂停，未成功使用的邀请码将暂时失效，已邀请且已注册的好友完成指定任务后仍可获得现金奖励；*/}
            {/*</span> */}
            <span>
              2.&nbsp;
              &nbsp;内测活动仅限200名用户参与，在Freelog内测用户满200人后，邀请好友活动将会暂停；
            </span>
            {/*<span className=''>*/}
            {/*  3.&nbsp;*/}
            {/*  &nbsp;每位用户在内测活动期间可获得1个邀请码，邀请码的有效使用次数为3次。*/}
            {/*  完成*/}
            {/*  <a*/}
            {/*    href={FI18n.i18nNext.tAuto('beta_event_guideline_newbie_link')}*/}
            {/*    target={'_blank'}*/}
            {/*  >*/}
            {/*    新手任务*/}
            {/*  </a>*/}
            {/*  中的【完善个人信息】【*/}
            {/*  Freelog社区签到】两个小任务，可额外各获得一个邀请名额。好友填写邀请码注册成功后，即消耗1次使用次数；*/}
            {/*</span>*/}
            <span>
              3.&nbsp;
              &nbsp;将邀请链接及个人邀请码分享给好友，好友通过您分享的链接和邀请码注册Freelog平台账号，您可领取3—20元现金奖励（累计奖励），同时好友可获得3元现金奖励；内测期间成功邀请好友所获取的累计奖励可在【个人中心】—【活动奖励】提现至微信钱包；
            </span>
            <span>
              4.&nbsp;
              &nbsp;随机抽取5位成功邀请好友的用户赠送价值100元的京东购物卡（电子卡），中奖用户名单将于
              {activityDetailsPage.announceTime?.format('YYYY年MM月DD日') || 'YYYY年MM月DD日'}
              公布；
            </span>
            {/*<span className=''>*/}
            {/*  5.&nbsp;*/}
            {/*  &nbsp;现金奖励发放方式及提现要求说明；*/}
            {/*</span>*/}
            <span>
              5.&nbsp;
              &nbsp;每位用户在内测活动期间可获得1个邀请码，邀请码的有效使用次数为5次，其中2次需完成特定新手任务解锁。好友填写邀请码注册成功后，即消耗1次使用次数；
            </span>
            {/*<div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>*/}
            {/*  <span className=''>*/}
            {/*    6.&nbsp; &nbsp;邀请好友参与Freelog内测活动*/}
            {/*    ，好友在7天内完成相应指定任务，即可领取3-20元现金奖励。可通过*/}
            {/*  </span>*/}
            {/*  <FComponentsLib.FTextBtn*/}
            {/*    type={'primary'}*/}
            {/*    onClick={() => {*/}
            {/*      self.open(*/}
            {/*        FUtil.Format.completeUrlByDomain('user') +*/}
            {/*        FUtil.LinkTo.reward(),*/}
            {/*      );*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    【个人中心】—【活动奖励】*/}
            {/*  </FComponentsLib.FTextBtn>*/}
            {/*  <span>，将内测期间领取的现金奖励申请提现至微信钱宝。</span>*/}
            {/*</div>*/}
            <span>
              6.&nbsp;
              &nbsp;对于存在非正常邀请行为的用户，平台将取消其活动参与资格，并扣除相应奖励不予结算；
            </span>
            <span>7.&nbsp; &nbsp;活动最终解释权归Freelog平台所有。</span>
          </div>
        </div>
        <FFooter />
      </div>
      {showInvite && (
        <div
          // className={'invite-text-container'}
          className={styles.inviteTextContainer}
          onClick={() => setShowInvite(false)}
        >
          <div
            // className={'invite-text flex-column align-center pt-30 pb-25 '}
            className={styles.inviteText}
            style={{
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
              paddingTop: '30px',
              paddingBottom: '25px',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <textarea
              readOnly
              // className='input mb-20'
              className={styles.input}
              style={{
                marginBottom: '20px',
              }}
              value={userData.textCopy || ''}
            />
            <FComponentsLib.FRectBtn
              onClick={() => {
                copy(userData.textCopy, {
                  format: 'text/plain',
                });
                fMessage(<span>复制成功！</span>, 'success');
              }}
            >
              复制内容
            </FComponentsLib.FRectBtn>
          </div>
        </div>
      )}
    </div>
  );
}

export default connect(({ activityDetailsPage }: ConnectState) => ({
  activityDetailsPage,
}))(InviteFriend);
